import { Package, ShoppingCart, Users, Wallet, ChevronRight } from "lucide-react";
import { formatRand } from "@/lib/api";
import { EmailAccountsList } from "@/components/admin/EmailAccountsList";

const cards = (stats) => [
  { key: "products", icon: Package, label: "Products", value: stats?.products, hint: "Manage inventory" },
  { key: "orders", icon: ShoppingCart, label: "Orders", value: stats?.orders, hint: "View & update orders" },
  { key: "clients", icon: Users, label: "Clients", value: stats?.clients, hint: "Client accounts" },
  { key: "revenue", icon: Wallet, label: "Revenue", value: stats && formatRand(stats.revenue), hint: "Paid orders only" },
];

export const DashboardView = ({ stats, onNavigate }) => (
  <div data-testid="admin-dashboard-view">
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 mb-10">
      {cards(stats).map((s) => (
        <button
          key={s.key}
          data-testid={`stat-card-${s.key}`}
          onClick={() => onNavigate(s.key)}
          className="group text-left bg-white rounded-2xl border border-purple-100 p-5 hover:border-fuchsia-300 hover:shadow-md transition-[box-shadow,border-color]"
        >
          <div className="w-10 h-10 rounded-xl brand-gradient flex items-center justify-center mb-3">
            <s.icon className="w-5 h-5 text-white" />
          </div>
          <p className="text-2xl font-bold text-purple-950" data-testid={`stat-${s.key}`}>{s.value ?? "—"}</p>
          <p className="text-sm text-muted-foreground">{s.label}</p>
          <p className="mt-3 text-xs font-medium text-purple-600 inline-flex items-center gap-1 group-hover:text-fuchsia-600">
            {s.hint} <ChevronRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
          </p>
        </button>
      ))}
    </div>

    <div className="flex items-center justify-between mb-3">
      <h3 className="font-semibold text-lg text-purple-950">Email accounts</h3>
      <button data-testid="dashboard-manage-emails" onClick={() => onNavigate("emails")} className="text-sm font-medium text-purple-700 hover:text-fuchsia-600">
        Create new email →
      </button>
    </div>
    <EmailAccountsList compact />
  </div>
);
